import I18nState from '@/types/store/i18n/I18nState';
import { SupportedLanguageCode } from './supportedLanguageCode';

let lang = localStorage.getItem('welcmLanguage');
if (!lang) {
  const systemLanguage = navigator.language;
  if (systemLanguage && systemLanguage.length) lang = systemLanguage.split('-')[0];
}

if (lang && !SupportedLanguageCode.includes(lang)) {
  lang = 'de';
}

const state: I18nState = {
  locale: lang || 'de',
  translations: {},
};

export default state;
